<template>
    <HeaderComp/>
    <main class="py-5 px-2">
        <router-view></router-view>
    </main>
    <FooterComp/>
</template>

<script>
import HeaderComp from '../../components/Auth/Header.vue'
import FooterComp from '../../components/Auth/Footer.vue'
export default {
    name: 'AuthView',
    components: {
        HeaderComp,
        FooterComp
    }
}
</script>

<style lang="scss" scoped>    
    main {
        box-shadow: inset 0 5px 10px 0 rgba(0, 0, 0, 0.3);
    }
</style>